import React, { useEffect, useRef } from "react";

type ButtonEvent = React.MouseEvent<HTMLButtonElement>;
type AnchorEvent = React.MouseEvent<HTMLAnchorElement>;

export interface ModalUserProps {
    toggle: boolean,
    mensaje:string
}

export const Modal = ({toggle, mensaje }:ModalUserProps) => {

    const anchorOpenRef = useRef<HTMLAnchorElement>(null);
    const anchorCloseRef = useRef<HTMLAnchorElement>(null);

    const divModal = useRef<HTMLDivElement>(null);

	useEffect(() => {
        /* cuerpo cuando se monta */
        if(toggle) {
            anchorOpenRef.current?.click();
        } else {
            anchorCloseRef.current?.click();
        }
        return () => {
            /* cuerpo cuando se desmonta */
        }
    }, [toggle]);

    return (
        <>
            <a data-toggle="modal" data-target="#modal" ref={anchorOpenRef} href="#">&nbsp;</a>
            <div id="modal" className="modal fade" ref={ divModal }  role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document"  >
                    <div className="modal-content">
                        <div id="" className="row">
                            <div className="col-12">
                                <div className="modal-header div-top-radius">
                                    <img src={ process.env.REACT_APP_CONTEXT_PATH + '/images/warning-naranja.png'} alt="advertencia" className="" />
                                    <button type="button" className="close" data-dismiss="modal" onClick={(e:ButtonEvent) =>{}}>&times;</button>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="modal-body modal-error" style={{ textAlign: 'center' }}>
                                    <img src={ process.env.REACT_APP_CONTEXT_PATH + '/images/datos-patron-no-correctos.png'} alt="advertencia" className="wd-15 pt-3 pb-5" width={90}/>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="modal-body modal-error" style={{ textAlign: 'center' }}>
                                    <span className="bold azul" id="mssgeError" >
                                        { mensaje }
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="modal-body modal-error radioclassName pt-5" style={{ textAlign: 'center' }} >
                                    <a className="btn boton-blanco-borde-rojo btn-block mt-3 mt-md-0 w-50" href="#" data-dismiss="modal" onClick={(e:AnchorEvent) =>{ e.preventDefault();}} ref={anchorCloseRef}>Salir</a>
                                </div>
                            </div>
                        </div >
                    </div>
                </div >
            </div>
        </>
    );
}